class NewsletterModal extends HTMLElement {
  constructor() {
    super();
    this.boundKeydown = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    this.modal = this.querySelector('.newsletter-modal');
    this.overlay = this.querySelector('.newsletter-modal__overlay');
    this.emailInput = this.querySelector('.newsletter-modal__email');
    this.submitBtn = this.querySelector('.newsletter-modal__submit');
    this.formWrapper = this.querySelector('.newsletter-modal__form-wrapper');
    this.successEl = this.querySelector('.newsletter-modal__success');
    this.closeBtn = this.querySelector('.newsletter-modal__close');
    this.checkboxes = this.querySelectorAll('input[type="checkbox"]');

    this.overlay.addEventListener('click', () => this.close());
    this.closeBtn.addEventListener('click', () => this.close());
    this.emailInput.addEventListener('input', () => this.validateEmail());
    this.submitBtn.addEventListener('click', (e) => this.handleSubmit(e));

    // Initialize submit button state
    this.validateEmail();
  }

  open() {
    this.classList.add('active');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', this.boundKeydown);
    trapFocus(this.modal);
  }

  close() {
    this.classList.remove('active');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this.boundKeydown);
    removeTrapFocus();

    // Reset form after close
    setTimeout(() => this.resetForm(), 300);
  }

  resetForm() {
    this.formWrapper.classList.remove('hidden');
    this.successEl.classList.add('hidden');
    this.emailInput.value = '';
    this.checkboxes.forEach(cb => cb.checked = false);
    this.validateEmail();
  }

  handleKeydown(e) {
    if (e.key === 'Escape') {
      this.close();
    }
  }

  validateEmail() {
    const email = this.emailInput.value.trim();
    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    this.submitBtn.disabled = !isValid;
  }

  async handleSubmit(e) {
    e.preventDefault();

    const form = this.querySelector('form');
    if (!form) return;

    const formData = new FormData(form);
    const email = formData.get('contact[email]');

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      return;
    }

    // Collect selected interests
    const interests = [];
    this.checkboxes.forEach((cb, idx) => {
      if (cb.checked) {
        interests.push(cb.value);
      }
    });
    if (interests.length > 0) {
      formData.set('contact[interest]', interests.join(','));
    }

    // Show loading state
    this.submitBtn.disabled = true;
    this.submitBtn.textContent = 'Subscribing...';

    try {
      const response = await fetch('/contact', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });

      if (response.ok || response.status === 422) {
        // Show success state
        this.formWrapper.classList.add('hidden');
        this.successEl.classList.remove('hidden');

        // Auto close after 3 seconds
        setTimeout(() => this.close(), 3000);
      } else {
        // Handle error - try native form submission as fallback
        form.submit();
      }
    } catch (err) {
      // Network error - fallback to native form submission
      form.submit();
    }
  }
}

customElements.define('newsletter-modal', NewsletterModal);
